import { IsOnTrack } from "../App"
import {
  Home,
  OrderFinishRoute,
  OrderRoute,
  OrdersRoute,
  RandomsPersonnelRoute,
  RandomsRoute,
  SelectionInboxRoute,
  SiteSearchOptionsRoute,
  SiteSearchRoute,
  ActivateCompanyRoute,
  ActivatePortalRoute,
  MyOrganizationRoute,
  MyOrganizationNameRoute,
  CompanyInformationRoute,
  InviteStatusRoute,
  MyInformationRoute,
  OrphanedResultsRoute,
  OurTeamStatusRoute,
  RegulatoryModeRoute,
  PermissionsRoute,
  GlobalParameterRoute,
  OrderableServicesRoute,
  UserCodesRoute,
  GovDonorRoute,
  RandomsGovRoute,
  ConsortiumsRoute,
  GovOrderRoute,
  SSOOrderRoute,
  SSOOrderFinishRoute,
  SSOSiteSearchRoute,
  SSOHome,
  ReportPositiveRoute,
  ReportSpecimenPositivityRoute,
  ReportDrugDetailRoute,
  ReportDailySummaryRoute,
  ReportIvrCallInComplianceRoute,
  ReportNoShowRoute,
  ReportTestingSummaryRoute,
  UserLabelsRoute,
  ReportCertificationRenewalRoute,
  ReportCertificationStatusRoute,
  ReportManagementSummaryRoute,
  ReportMISRoute,
  ReportSummaryRoute,
  LocationInformationRoute,
  PortalAdministrationRoute,
  AddNewPortalRoute,
  ActivateUserRoute,
  ConfigureOrderDefaultsRoute,
  AddNewCompanyRoute,
  AddNewCompanyNameRoute,
  SendingFacilityRoute,
  ConsortiumPersonnelRoute,
  CompanyInformationNameRoute,
  ReportSelectedNotTestedRoute,
  SSOGetAuthFormRoute,
  LabResultsReportingRoute,
  ReportUnmergedRandomResultsRoute
} from "../config/Routes"
import { GetSSOAction, SiteSearchModeEnabled } from "../storage/AuthToken"
import UserAccessSettings from "./UserAccessSettings"
import UserState from "./UserState"

export function HasAccessToAtLeastOneRoute(routes: string[], userAccess: UserAccessSettings, userState: UserState): boolean {
  return routes.some(route => HasAccessToRoute(route, userAccess, userState))
}

export default function HasAccessToRoute(route: string | undefined, userAccess: UserAccessSettings, userState: UserState): boolean {
  if (route === undefined || (!userState.selectedCompany && !userState.selectedPortal)) {
    return false
  }
  const ssoRoutes = [SSOOrderRoute, SSOOrderFinishRoute, SSOSiteSearchRoute, SSOGetAuthFormRoute]
  const isSiteSearchMode = SiteSearchModeEnabled()
  const isGetAuthFormMode = GetSSOAction() === "getauthform"
  const isLocation = (userState.selectedCompany?.LocationID || 0) > 0
  if (userState.ssoToken !== "" && !ssoRoutes.includes(route) || userState.ssoToken === "" && ssoRoutes.includes(route)) {
    return false
  }

  switch (route) {
    case InviteStatusRoute: return userAccess.canShowInvitationStatus
    case RandomsRoute: return userAccess.canManagePools && !isLocation
    case RandomsRoute: return userAccess.canManagePools
    case RandomsPersonnelRoute: return userAccess.canManagePersonnel
    case SelectionInboxRoute: return userAccess.canManageSelectionInbox
    case OrderRoute: return userAccess.canViewOrder
    case OrderFinishRoute: return userAccess.canViewOrder
    case SiteSearchRoute: return userAccess.canViewSiteSearch
    case OrdersRoute: return userAccess.canViewOrderTrackingGrid
    case OurTeamStatusRoute: return userAccess.isSiteAdmin || userAccess.isPortalAdmin || userAccess.isCompanyAdmin || userAccess.isLocationAdmin
    case CompanyInformationRoute: return (userAccess.isSiteAdmin || userAccess.isPortalAdmin || userAccess.isCompanyAdmin) && userAccess.canManageClient
    case LocationInformationRoute: return userAccess.isLocationAdmin
    case ActivateUserRoute: return userAccess.isSiteAdmin || userAccess.isPortalAdmin || userAccess.isCompanyAdmin || userAccess.isLocationAdmin
    case OrphanedResultsRoute: return userAccess.canShowOrphanedResults && (userAccess.isSiteAdmin || userAccess.isPortalAdmin || userAccess.isCompanyAdmin)
    case MyOrganizationRoute: return userAccess.isPortalAdmin
    case AddNewCompanyRoute: return userAccess.isPortalAdmin && userAccess.canCreateClient
    case CompanyInformationNameRoute: return userAccess.isSiteAdmin || userAccess.isPortalAdmin || userAccess.isCompanyAdmin
    case AddNewCompanyNameRoute: return userAccess.isSiteAdmin
    case MyOrganizationNameRoute: return userAccess.isSiteAdmin
    case PortalAdministrationRoute: return userAccess.isSiteAdmin
    case AddNewPortalRoute: return userAccess.isSiteAdmin
    case ActivateCompanyRoute: return userAccess.isSiteAdmin || userAccess.isPortalAdmin
    case SiteSearchOptionsRoute: return userAccess.canSearchDefaults
    case GlobalParameterRoute: return userAccess.isSiteAdmin
    case ActivatePortalRoute: return userAccess.isSiteAdmin
    case RegulatoryModeRoute: return userAccess.isSiteAdmin
    case PermissionsRoute: return userAccess.isSiteAdmin && userAccess.canShowRolePermissionSubscription
    case MyInformationRoute: return true
    case OrderableServicesRoute: return userAccess.isSiteAdmin || userAccess.isPortalAdmin
    case UserCodesRoute: return !IsOnTrack() && (userAccess.isPortalAdmin || userAccess.isCompanyAdmin)
    case RandomsGovRoute: return userAccess.CanManageGovPools
    case ConsortiumsRoute: return (userAccess.CanManageConsortiumPools || userAccess.canManagePools) && !userAccess.isLocationAdmin
    case ConsortiumPersonnelRoute: return userAccess.CanManageConsortiumPools && userAccess.isPortalAdmin
    case GovDonorRoute: return userAccess.CanManageGovDonors
    case GovOrderRoute: return userAccess.CanOrderGovServices
    case SSOOrderRoute: return userAccess.canViewOrder && !isGetAuthFormMode
    case SSOOrderFinishRoute: return userAccess.canViewOrder && !isGetAuthFormMode
    case SSOSiteSearchRoute: return userAccess.canViewOrder && isSiteSearchMode 
    case SSOGetAuthFormRoute: return userAccess.canViewOrder && isGetAuthFormMode
    case SendingFacilityRoute: return userAccess.isSiteAdmin
    case Home: return true
    case SSOHome: return true
    case ReportPositiveRoute: return userAccess.isPortalAdmin
    case ReportTestingSummaryRoute: return userAccess.isPortalAdmin || userAccess.isCompanyAdmin || userAccess.isLocationAdmin
    case ReportSpecimenPositivityRoute: return userAccess.isPortalAdmin || userAccess.isCompanyAdmin || userAccess.isLocationAdmin
    case ReportDrugDetailRoute: return userAccess.isPortalAdmin || userAccess.isCompanyAdmin || userAccess.isLocationAdmin
    case ReportDailySummaryRoute: return userAccess.isPortalAdmin || userAccess.isCompanyAdmin || userAccess.isLocationAdmin
    case ReportIvrCallInComplianceRoute: return userAccess.isPortalAdmin || userAccess.isCompanyAdmin || userAccess.isLocationAdmin
    case ReportNoShowRoute: return userAccess.isPortalAdmin || userAccess.isCompanyAdmin || userAccess.isLocationAdmin
    case UserLabelsRoute: return userAccess.isPortalAdmin
    case ReportCertificationRenewalRoute: return userAccess.canViewMISReports
    case ReportCertificationStatusRoute: return userAccess.canViewMISReports
    case ReportManagementSummaryRoute: return userAccess.canViewMISReports
    case ReportMISRoute: return userAccess.canViewMISReports
    case ReportSelectedNotTestedRoute: return userAccess.isPortalAdmin || userAccess.isCompanyAdmin
    case ReportSummaryRoute: return userAccess.isPortalAdmin || userAccess.isCompanyAdmin
    case ConfigureOrderDefaultsRoute: return (!IsOnTrack() && userAccess.isPortalAdmin) || userAccess.isSiteAdmin
    case LabResultsReportingRoute: return userAccess.isSiteAdmin || userAccess.isPortalAdmin
    case ReportUnmergedRandomResultsRoute: return userAccess.isPortalAdmin || userAccess.isCompanyAdmin
    default: return false
  }
}
